<template>
  <div id="chain-info" class="grid">
    <div class="grid-title">
      <h4>{{ $t('CHAIN_REGIS_INFO') }}</h4>
    </div>
    <div class="grid-body p-3 border-top-unset">
      <v-form ref="form" lazy-validation v-on:submit.prevent v-if="!isLoading">
        <v-row class="mt-0">
          <v-col sm="9" class="pt-0">
            <v-tabs v-model="tab" class="pl-0">
              <v-tab>{{ $t("DEFAULT") }}</v-tab>
              <v-tab>{{ $t("VIETNAMESE") }}</v-tab>
              <v-tab>{{ $t("ENGLISH") }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("_HOTEL_CHAIN.CHAIN_NAME") }} *</label>
                    <v-text-field v-model="data.nameVi" outlined dense :rules="ruleName" counter maxlength="250"
                      class="input-counter" v-on:keyup="updateTitle(data.nameVi)"></v-text-field>
                  </v-col>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea :rows="6" v-model="data.descriptionVi" outlined dense counter="300" maxlength="300"
                      :rules="ruleDescNotRequired" class="input-counter"
                      v-on:keyup="updateDescription(data.descriptionVi)"></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("_HOTEL_CHAIN.CHAIN_NAME") }} *</label>
                    <v-text-field v-model="data.chainI18n.find(x => x.lang == 'vi').name" outlined dense counter
                      maxlength="250" class="input-counter" :rules="ruleName"></v-text-field>
                  </v-col>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea :rows="6" v-model="data.chainI18n.find(x => x.lang == 'vi').description" outlined dense
                      counter="300" maxlength="300" class="input-counter" :rules="ruleDescNotRequired"></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("_HOTEL_CHAIN.CHAIN_NAME") }} *</label>
                    <v-text-field v-model="data.chainI18n.find(x => x.lang == 'en').name" outlined dense counter
                      maxlength="250" class="input-counter" :rules="ruleName"></v-text-field>
                  </v-col>
                  <v-col sm="12" class="pb-0">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea :rows="6" v-model="data.chainI18n.find(x => x.lang == 'en').description" outlined
                      counter="300" maxlength="300" class="input-counter" :rules="ruleDescNotRequired" dense></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <v-col sm="3">
            <p class="pl-3 m-0">{{ $t("_ACCOUNT_SETTING.AVATAR") }} *</p>
            <div class="d-flex">
              <div class="square" @mouseover="changeImageOverlay(true)" @mouseleave="changeImageOverlay(false)">
                <img v-if="!imagePreview" src="@/assets/no-image.jpg" class="square-content" />
                <img v-else :src="imagePreview" class="square-content" />
                <!-- <v-img v-if="imagePreview" :src="imagePreview" class="square-content" /> -->
                <v-overlay :absolute="true" :value="showImageOverlay">
                  <div class="d-flex">
                    <label class="d-flex justify-center btn-icon label-upload" for="input-file">
                      <v-icon color="#173d8f">mdi-upload</v-icon>
                    </label>
                    <input class="d-none" style="display: none" type="file" :value="fileUpload"
                      @change="changeImage($event)" accept="image/*" id="input-file" />
                  </div>
                </v-overlay>
              </div>
            </div>
            <p v-if="isNoThumb" class="text-danger">
              {{ $t("SERVICE.NOTHUMB") }}
            </p>
            <p v-if="isImageLarge" class="text-danger">
              {{ $t("SERVICE.IMAGE_TOO_LARGE") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="3" class="pb-0">
            <label>{{ $t("CHAIN_CODE") }}</label>
            <v-text-field v-model="data.chainCode" disabled :rules="ruleCode" outlined dense>
            </v-text-field>
          </v-col>
          <v-col sm="3" class="pb-0">
            <label>{{ $t("STATUS") }}</label>
            <p class="mb-0 pt-2">{{ data.status ? $t('ACTIVE') : $t('DEACTIVE') }}</p>
          </v-col>
          <v-col sm="3" class="pb-0">
            <label>{{ $t("CHAIN_TYPE") }}</label>
            <v-select :items="typeOption" v-model="data.chainType" outlined dense item-text="nameVi"
              item-value="lookupItemCode"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <v-btn color="primary" @click="updateChain" class="pl-10 pr-10">{{ $t("SAVE") }}</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { chainService } from "@/_services/ChainManage/chain.service.js";
import { _alert } from "@/_helpers/function.js";

export default {
  data() {
    return {
      isLoading: true,
      sysLang: this.$i18n.locale,
      langTab: "vi",
      tab: null,
      data: {
        i18ns: []
      },
      typeOption: [],
      showImageOverlay: false,
      fileUpload: "",
      imagePreview: "",
      isNoThumb: false,
      isImageLarge: false,
    };
  },

  created() {
    this.initialize();
  },
  mounted() { },
  watch: {},
  methods: {
    initialize() {
      this.getInfo();
    },
    getInfo() {
      chainService.getChainInfo().then(res => {
        if (res.responseCode === 0) {
          this.data = res.data;
          this.imagePreview = this.data.defaultImageUrl;
          this.getChainType();
        }
      });
    },
    getChainType() {
      chainService.getChainType().then(res => {
        if (res.responseCode === 0) {
          this.typeOption = res.data;
          this.isLoading = false;
        }
      });
    },
    updateTitle(value) {
      if (value.length > 0) {
        for (let i = 0; i < this.data.chainI18n.length; i++) {
          this.data.chainI18n[i].name = value;
        }
      }
    },
    updateDescription(value) {
      for (let i = 0; i < this.data.chainI18n.length; i++) {
        this.data.chainI18n[i].description = value;
      }
    },

    updateChain() {
      let form_validate = this.$refs.form.validate();
      if (
        !this.data.defaultImageThumbUrl ||
        !this.data.defaultImageId
      ) {
        this.isNoThumb = true;
      }
      if (!form_validate || this.isNoThumb) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false
        });
        const el = document.querySelector(
          ".v-messages.error--text:first-of-type"
        );
        el.scrollIntoView();
        return false;
      }
      this.isImageLarge = false;
      // const body = {
      //     id: this.data.id,
      //     nameVi: this.data.nameVi,
      //     chainType: this.data.chainType,
      //     descriptionVi: this.data.descriptionVi,
      //     chainI18n: [...this.data.chainI18n]
      // }
      chainService.updateChainInfo(this.data).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    changeImageOverlay(visible) {
      this.showImageOverlay = visible;
    },
    changeImage(input) {
      const formData = new FormData();
      formData.append("file", input.target.files[0]);
      // console.log(input.target);

      this.imageFormData = formData;
      if (input.target.files[0].size < 8388608) {
        this.isImageLarge = false;
        chainService.uploadImage(formData).then(res => {
          if (res.responseCode === 0) {
            this.data.defaultImageThumbUrl = res.data.img;
            this.data.defaultImageId = res.data.id;
            this.imagePreview = res.data.img;
            if (this.isNoThumb) {
              this.isNoThumb = false;
            }
            _alert(res, this.$t("SERVICE.UPDATE_IMAGE_SUCCESS"), false);
          } else {
            _alert(res, this.$t("SERVICE.UPDATE_IMAGE_FAIL"), false);
            if (!this.data.defaultImageThumbUrl) {
              this.isNoThumb = true;
            }
          }
        });
      } else {
        this.isImageLarge = true;
      }
    },
    deleteImage() {
      chainService
        .removeImage(this.data.defaultImageId)
        .then(res => {
          _alert(res, this.$t(res.data), false);
        });
    },

  }
};
</script>
<style lang="scss" scoped>
#chain-info {
  .square {
    position: relative;
    flex-basis: 100%;
    box-sizing: border-box;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    &::before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    & .square-content {
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
}
</style>
